import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useAuth } from '../../components/auth/useAuth'


export default function NotFoundPage () {
    const { t } = useTranslation()
	const {clientauth} = useAuth()
    const role = String(clientauth?.rol || '').toLowerCase()
    const homePath = !role
        ? '/'
        : role === 'commercial'
            ? `/${role}/chatbot`
            : `/${role}/dashboard`

	return (
        <div className="empty-state" style={{ paddingTop: '80px' }}>
            <div className="empty-state-icon" style={{ opacity: 0.2, fontSize: '64px' }}>
                <i className="fas fa-map-signs"></i>
            </div>
            <h2 className="h2 mb-3">{t('global.pagenotfound')}</h2>
            <p className="text-muted mb-4" style={{ fontSize: '15px', maxWidth: '400px', margin: '0 auto' }}>
                {t('global.error404description')}
            </p>
            <Link to={homePath} className="btn btn-primary">
                <i className="fas fa-home me-2"></i>{t('global.home')}
            </Link>
        </div>
	)
}
